import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFlagUkGlyph from './svgs/FlagUkGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var flagUkGlyph = (props => useIcon(SvgFlagUkGlyph, SvgFlagUkGlyph, props));

export { flagUkGlyph as default };
